export default "__VITE_ASSET__4609027d__$_?nuxt_component=async__"